import {css} from '@emotion/css';
import {Breakpoints, mq} from '@fo/shared/styles/mixins';
import {containerStackMobile} from '@fo/shared/styles/mixins/layout';
import {colours, spacing} from '@fo/shared/styles/variables';

const styles = {
  informationCard: (bordered = false): string => css`
    label: informationCard;
    margin: 0 auto ${spacing.S};
    padding: ${spacing.XS};
    ${bordered &&
    css`
      border: 1px solid ${colours.border.LIGHT_GRAY};
    `}
  `,
  paragraph: css`
    label: informationCard__paragraph;
    margin-bottom: ${spacing.XXS};
    color: ${colours.font.DARK_GRAY};

    &:first-of-type {
      color: ${colours.font.BLACK};
    }

    &:last-child {
      margin-bottom: 0;
    }
  `,
  container: css`
    label: informationCard__container;
    ${containerStackMobile};
  `,
  description: css`
    label: informationCard__description;
    color: ${colours.font.ASSISTIVE};
    margin-bottom: ${spacing.XS};
    ${mq(Breakpoints.TABLET)} {
      flex: 1 1 auto;
      margin-right: ${spacing.XS};
      margin-bottom: 0;
    }

    > *:last-child {
      margin-bottom: 0;
    }
  `,
  conditions: css`
    label: informationCard__conditions;
    flex: 0 0 30%;
  `,
  conditionBox: css`
    label: informationCard__conditionBox;
    margin-bottom: ${spacing.XXXS};
    padding: ${spacing.XXS};
    border: 1px solid ${colours.border.LIGHT_GRAY};
    border-radius: 0.4rem;
  `,
};

export default styles;
